/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ExclamationMarkBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zm0 8.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 018 9.5zm0 1a.5.5 0 100 1 .5.5 0 000-1zM8.99 3c.558 0 .935.45.845.99l-.67 4.02C9.075 8.555 8.555 9 8 9c-.552 0-1.075-.45-1.165-.99l-.67-4.02c-.09-.546.278-.99.844-.99H8.99zm-.171 1H7.181l.641 3.846-.002-.001c.012.062.12.155.18.155.065 0 .167-.088.18-.155L8.819 4z"
        />
    </AccessibleSVG>
);

export default ExclamationMarkBadge16;
